import { NavigationGroup } from "./navigation-item.model";

export const SUPER_ADMIN_NAVIGATION_ITEMS: NavigationGroup[] = [
  {
    items: [
      { title: 'nav.items.dashboard', icon: 'bi bi-house', link: '/' },
      { title: 'nav.items.all_users', icon: 'bi bi-people', link: '/users' },
      { title: 'nav.items.notifications_center', icon: 'bi bi-megaphone', link: '/notifications' },
      { title: 'nav.items.inquiries', icon: 'bi bi-inbox', link: '/inquiries' },
      { title: 'nav.items.reports', icon: 'bi bi-file-earmark-text', link: '/reports' },
      { title: 'nav.items.sections', icon: 'bi bi-grid', link: '/sections' },
      { title: 'nav.items.delivery_zones', icon: 'bi bi-map', link: '/zones' },
    ]
  },
  {
    groupTitle: 'nav.groups.vendors',
    items: [
      { title: 'nav.items.vendors_list', icon: 'bi bi-shop', link: '/vendors' },
      { title: 'nav.items.add_vendor', icon: 'bi bi-plus-circle', link: '/vendors/new' },
    ]
  },
  {
    groupTitle: 'nav.groups.contact_us',
    items: [
      { title: 'nav.items.about_us', icon: 'bi bi-info-circle', link: '/about-us' },
      { title: 'nav.items.terms', icon: 'bi bi-book', link: '/terms-and-conditions' },
      { title: 'nav.items.privacy', icon: 'bi bi-file-earmark-lock', link: '/privacy-policy' }
    ]
  },
  {
    items: [
      { title: 'nav.items.logout', icon: 'bi bi-box-arrow-right', link: '/login' }
    ]
  }
];
